import React, { useState, useEffect } from 'react';
import SessionDetail from '../components/SessionDetail';
import ExportModal from '../components/ExportModal';

const API = 'https://green-energy.com.co/api';

const PERIODOS = [
  { label: 'Hoy', get: () => {
    const d = new Date(); const f = d.toISOString().slice(0,10);
    return { fi: f, hi: '00:00', ff: f, hf: '23:59' };
  }},
  { label: 'Ayer', get: () => {
    const d = new Date(); d.setDate(d.getDate()-1); const f = d.toISOString().slice(0,10);
    return { fi: f, hi: '00:00', ff: f, hf: '23:59' };
  }},
  { label: 'Última noche', get: () => {
    const hoy = new Date(); const ayer = new Date();
    ayer.setDate(ayer.getDate()-1);
    return { fi: ayer.toISOString().slice(0,10), hi: '22:00', ff: hoy.toISOString().slice(0,10), hf: '08:00' };
  }},
  { label: 'Esta semana', get: () => {
    const hoy = new Date(); const ini = new Date();
    ini.setDate(hoy.getDate() - hoy.getDay());
    return { fi: ini.toISOString().slice(0,10), hi: '00:00', ff: hoy.toISOString().slice(0,10), hf: '23:59' };
  }},
  { label: 'Este mes', get: () => {
    const hoy = new Date();
    const ini = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    return { fi: ini.toISOString().slice(0,10), hi: '00:00', ff: hoy.toISOString().slice(0,10), hf: '23:59' };
  }},
  { label: 'Mes anterior', get: () => {
    const hoy = new Date();
    const ini = new Date(hoy.getFullYear(), hoy.getMonth()-1, 1);
    const fin = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
    return { fi: ini.toISOString().slice(0,10), hi: '00:00', ff: fin.toISOString().slice(0,10), hf: '23:59' };
  }},
  { label: 'Todo', get: () => ({ fi: '', hi: '', ff: '', hf: '' }) },
];

export default function Historial() {
  const [txs, setTxs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showExport, setShowExport] = useState(false);
  const [search, setSearch] = useState('');
  const [filterCop, setFilterCop] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterCargador, setFilterCargador] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [horaInicio, setHoraInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [horaFin, setHoraFin] = useState('');
  const [periodoActivo, setPeriodoActivo] = useState('Todo');
  const [page, setPage] = useState(1);
  const [selectedTx, setSelectedTx] = useState(null);
  const perPage = 15;

  useEffect(() => {
    fetch(`${API}/transactions`)
      .then(r => r.json())
      .then(data => {
        const normalized = data.map(t => ({
          txId: t.tx_id || t.txId,
          cpId: t.cp_id || t.cpId,
          idTag: t.id_tag || t.idTag || 'AUTOSTART',
          cop: t.cop || 'Usme',
          connectorId: t.connector_id || t.connectorId || 1,
          meterStart: t.meter_start || t.meterStart || 0,
          meterStop: t.meter_stop || t.meterStop || 0,
          startTime: t.start_time || t.startTime,
          stopTime: t.stop_time || t.stopTime,
          status: t.status || 'Active',
          energyDelivered: t.energy_delivered || t.energyDelivered || 0,
          socStart: t.soc_start || t.socStart || 0,
          socEnd: t.soc_end || t.socEnd || 0,
          vin: t.vin || null,
          zonal: t.zonal || null,
        })).map(t => ({
          ...t,
          duracion: t.startTime && t.stopTime
            ? Math.round((new Date(t.stopTime) - new Date(t.startTime)) / 60000) : 0,
        }));
        setTxs(normalized);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const aplicarPeriodo = (p) => {
    const r = p.get();
    setFechaInicio(r.fi); setHoraInicio(r.hi);
    setFechaFin(r.ff); setHoraFin(r.hf);
    setPeriodoActivo(p.label);
    setPage(1);
  };

  const cargadoresUnicos = [...new Set(txs.map(t => t.cpId))].sort();

  const filtered = txs.filter(t => {
    if (search && !t.idTag?.toLowerCase().includes(search.toLowerCase())
      && !t.cpId?.toLowerCase().includes(search.toLowerCase())
      && !t.vin?.toLowerCase().includes(search.toLowerCase())
      && !t.zonal?.toLowerCase().includes(search.toLowerCase())) return false;
    if (filterCop && t.cop !== filterCop) return false;
    if (filterStatus && t.status !== filterStatus) return false;
    if (filterCargador && t.cpId !== filterCargador) return false;
    if (fechaInicio) {
      const desde = new Date(`${fechaInicio}T${horaInicio || '00:00'}:00`);
      if (new Date(t.startTime) < desde) return false;
    }
    if (fechaFin) {
      const hasta = new Date(`${fechaFin}T${horaFin || '23:59'}:59`);
      if (new Date(t.startTime) > hasta) return false;
    }
    return true;
  });

  const limpiarFiltros = () => {
    setSearch(''); setFilterCop(''); setFilterStatus('');
    setFilterCargador(''); setFechaInicio(''); setHoraInicio('');
    setFechaFin(''); setHoraFin(''); setPeriodoActivo('Todo'); setPage(1);
  };

  const pages = Math.ceil(filtered.length / perPage);
  const rows = filtered.slice((page-1)*perPage, page*perPage);
  const pad = n => String(n).padStart(2,'0');
  const durStr = m => m>0?(m>=60?`${Math.floor(m/60)}h ${pad(m%60)}m`:`${m}m`):'—';
  const socColor = s => s>=75?'#4ade80':s>=40?'#60a5fa':'#f59e0b';
  const formatTime = ts => { try { return new Date(ts).toLocaleTimeString('es-CO'); } catch(e) { return '—'; } };
  const formatDate = ts => { try { return new Date(ts).toLocaleDateString('es-CO'); } catch(e) { return '—'; } };

  const statusTag = s => {
    const map = {
      Completed: ['#1a3a2a','#4ade80','Completada'],
      Active: ['#1a2a3a','#60a5fa','En carga'],
      Error: ['#3a1a1a','#f87171','Error']
    };
    const [bg,col,label] = map[s] || ['#2a2a2a','#888',s];
    return <span style={{background:bg,color:col,padding:'2px 8px',borderRadius:'5px',fontSize:'11px',fontWeight:'500'}}>{label}</span>;
  };

  const totalEnergy = filtered.reduce((a,t) => a+(t.energyDelivered||0), 0);
  const socFins = filtered.filter(t=>t.socEnd>0);
  const avgSoc = socFins.length>0 ? Math.round(socFins.reduce((a,t)=>a+t.socEnd,0)/socFins.length) : 0;
  const hayFiltros = search||filterCop||filterStatus||filterCargador||fechaInicio||fechaFin;

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'1.5rem',flexWrap:'wrap',gap:'12px'}}>
        <div className="page-title" style={{margin:0}}>Historial de sesiones</div>
        <button onClick={() => setShowExport(true)} disabled={filtered.length===0}
          style={{padding:'8px 20px',background:'#1d6a3a',border:'none',borderRadius:'7px',
            color:'#fff',cursor:'pointer',fontSize:'13px',fontWeight:'600',display:'flex',alignItems:'center',gap:'8px'}}>
          📊 Generar Reporte Excel
        </button>
      </div>

      <div className="metrics">
        <div className="metric-card"><div className="metric-label">Sesiones</div><div className="metric-value">{filtered.length}</div><div className="metric-sub">de {txs.length} totales</div></div>
        <div className="metric-card"><div className="metric-label">Energía total</div><div className="metric-value">{totalEnergy.toLocaleString()} kWh</div></div>
        <div className="metric-card"><div className="metric-label">SoC final prom.</div><div className="metric-value">{avgSoc}%</div></div>
        <div className="metric-card"><div className="metric-label">Errores</div><div className="metric-value" style={{color:'#f87171'}}>{filtered.filter(t=>t.status==='Error').length}</div></div>
      </div>

      <div className="card" style={{marginBottom:'1.25rem'}}>
        {/* Períodos rápidos */}
        <div style={{display:'flex',gap:'6px',marginBottom:'14px',flexWrap:'wrap'}}>
          {PERIODOS.map(p => (
            <button key={p.label} onClick={() => aplicarPeriodo(p)}
              style={{padding:'5px 12px',border:'1px solid',borderRadius:'6px',cursor:'pointer',fontSize:'12px',fontWeight:'500',
                background: periodoActivo===p.label?'#2a2d3a':'#13151f',
                borderColor: periodoActivo===p.label?'#4ade80':'#2a2d3a',
                color: periodoActivo===p.label?'#4ade80':'#666'}}>
              {p.label}
            </button>
          ))}
        </div>

        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px'}}>
          <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
            <input placeholder="Buscar bus, zonal, VIN o cargador..." value={search}
              onChange={e=>{setSearch(e.target.value);setPage(1);setPeriodoActivo('');}} />
            <div style={{display:'flex',gap:'8px'}}>
              <select value={filterCop} onChange={e=>{setFilterCop(e.target.value);setPage(1);}} style={{flex:1}}>
                <option value="">Todos los COP</option>
                <option value="Fontibón">Fontibón</option>
                <option value="Usme">Usme</option>
              </select>
              <select value={filterStatus} onChange={e=>{setFilterStatus(e.target.value);setPage(1);}} style={{flex:1}}>
                <option value="">Todos los estados</option>
                <option value="Completed">Completada</option>
                <option value="Active">En carga</option>
                <option value="Error">Error</option>
              </select>
            </div>
            <select value={filterCargador} onChange={e=>{setFilterCargador(e.target.value);setPage(1);}}>
              <option value="">Todos los cargadores</option>
              {cargadoresUnicos.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>

          <div style={{display:'flex',flexDirection:'column',gap:'8px'}}>
            <div style={{fontSize:'12px',color:'#666',fontWeight:'500'}}>Rango personalizado</div>
            <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
              <div style={{flex:1}}>
                <div style={{fontSize:'11px',color:'#555',marginBottom:'3px'}}>Desde</div>
                <div style={{display:'flex',gap:'4px'}}>
                  <input type="date" value={fechaInicio}
                    onChange={e=>{setFechaInicio(e.target.value);setPeriodoActivo('');setPage(1);}} style={{flex:1}} />
                  <input type="time" value={horaInicio}
                    onChange={e=>{setHoraInicio(e.target.value);setPeriodoActivo('');setPage(1);}} style={{width:'95px'}} />
                </div>
              </div>
              <span style={{color:'#444',marginTop:'16px'}}>→</span>
              <div style={{flex:1}}>
                <div style={{fontSize:'11px',color:'#555',marginBottom:'3px'}}>Hasta</div>
                <div style={{display:'flex',gap:'4px'}}>
                  <input type="date" value={fechaFin}
                    onChange={e=>{setFechaFin(e.target.value);setPeriodoActivo('');setPage(1);}} style={{flex:1}} />
                  <input type="time" value={horaFin}
                    onChange={e=>{setHoraFin(e.target.value);setPeriodoActivo('');setPage(1);}} style={{width:'95px'}} />
                </div>
              </div>
            </div>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <span style={{fontSize:'12px',color:'#555'}}>{filtered.length} sesiones encontradas</span>
              {hayFiltros && (
                <button onClick={limpiarFiltros}
                  style={{padding:'4px 12px',background:'#2a2d3a',border:'none',borderRadius:'6px',color:'#aaa',cursor:'pointer',fontSize:'12px'}}>
                  ✕ Limpiar filtros
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="card" style={{textAlign:'center',padding:'3rem',color:'#666'}}>Cargando sesiones...</div>
      ) : (
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>ID Tx</th><th>Bus / Zonal</th><th>Cargador</th><th>P.</th><th>COP</th>
                <th>Fecha</th><th>Inicio</th><th>Fin</th><th>Duración</th>
                <th>SoC inicio→fin</th><th>Energía</th><th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(t => (
                <tr key={t.txId} onClick={()=>setSelectedTx(t.txId)} style={{cursor:'pointer'}}>
                  <td style={{fontFamily:'monospace',fontSize:'11px',color:'#666'}}>{t.txId}</td>
                  <td>{t.zonal
                    ? <span style={{color:'#4ade80',fontWeight:'500',fontSize:'12px'}}>{t.zonal}</span>
                    : <span className="badge" style={{fontSize:'10px'}}>{t.idTag}</span>}
                  </td>
                  <td style={{color:'#aaa',fontSize:'12px'}}>{t.cpId}</td>
                  <td style={{color:'#666',fontSize:'11px'}}>P{t.connectorId}</td>
                  <td style={{color:'#aaa',fontSize:'12px'}}>{t.cop}</td>
                  <td style={{color:'#666',fontSize:'12px'}}>{formatDate(t.startTime)}</td>
                  <td style={{color:'#666',fontSize:'12px'}}>{formatTime(t.startTime)}</td>
                  <td style={{color:'#666',fontSize:'12px'}}>{formatTime(t.stopTime)}</td>
                  <td>{durStr(t.duracion)}</td>
                  <td>
                    <div style={{display:'flex',alignItems:'center',gap:'6px'}}>
                      <span style={{color:'#666',minWidth:'26px',fontSize:'11px'}}>{t.socStart}%</span>
                      <span style={{color:'#444'}}>→</span>
                      <div className="soc-bar-bg" style={{width:'50px'}}>
                        <div className="soc-bar-fill" style={{width:`${t.socEnd}%`,background:socColor(t.socEnd)}}></div>
                      </div>
                      <span style={{fontWeight:'500',color:socColor(t.socEnd),minWidth:'26px',fontSize:'11px'}}>{t.socEnd}%</span>
                    </div>
                  </td>
                  <td style={{fontWeight:'500'}}>{t.energyDelivered} kWh</td>
                  <td>{statusTag(t.status)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="pagination">
            <span>{(page-1)*perPage+1}–{Math.min(page*perPage,filtered.length)} de {filtered.length}</span>
            <button onClick={()=>setPage(p=>p-1)} disabled={page===1}>← Anterior</button>
            <button onClick={()=>setPage(p=>p+1)} disabled={page>=pages}>Siguiente →</button>
          </div>
        </div>
      )}

      {showExport && <ExportModal filtered={filtered} onClose={()=>setShowExport(false)} />}
      {selectedTx && <SessionDetail txId={selectedTx} onClose={()=>setSelectedTx(null)} />}
    </div>
  );
}
